module.exports = __webpack_public_path__ + "fonts/eaa9c8f0d07bcd171b693032b40fca14.svg";